import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  DropdownButton,
  ButtonGroup,
  MenuItem,
  FormControl,
  InputGroup,
  Glyphicon,
  Tabs,
  Tab,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import {
  get_merchant_list,
  delete_merchant,
  unArchive
} from "../../../redux/actions/merchantActions";
import Dialog from "react-bootstrap-dialog";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util";
import './Merchant.css'

const history = createBrowserHistory();
class MerchantList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      limit:25,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      menuKey: 'LIST_MERCHANT',
      path: ["Home", "Manage Merchants"],
      links:["home", "merchantList"],
      emailSortIcon: "",
      firstNameSortIcon: "",
      lastNameSortIcon: "",
      merchantNameSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      show: false,
      tabStatus: 'Active',
      userType: localStorage.getItem("userTypeName"),
    };
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleUnArchive = (merchantID, merchantName) => {
    const postData = {
      merchantName: merchantName,
      id: merchantID,
      status: 'Active',
    }

    this.dialog.show({
      body: "Are you sure you want to active this merchant?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmUnArchive(postData);
        })
      ]
    });
  }

  confirmUnArchive = (postData) => {
    this.props.unArchive(postData);
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_merchant_list({
        status: this.state.tabStatus,
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit,
        pageName:"merchantListingPage"
      });
    } else if (this.state.searchString !== "") {
      this.props.get_merchant_list({
        status: this.state.tabStatus,
        page: page,
        search: this.state.searchString,
        limit: this.state.limit,
        pageName:"merchantListingPage"
      });
    } else {
      this.props.get_merchant_list({ status: this.state.tabStatus, page: page,  limit: this.state.limit, pageName:"merchantListingPage" });
    }
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    if (searchString.length > 0) {
      this.props.get_merchant_list({ search: searchString, status: this.state.tabStatus, pageName:"merchantListingPage" });
    } else {
      this.props.get_merchant_list({ page: this.state.currentPage, limit: this.state.limit, status: this.state.tabStatus, pageName:"merchantListingPage" });
    }

    this.setState({ searchString: searchString });
  };

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.get_merchant_list({ orderBy: orderBy, direction: direction, limit: this.state.limit, pageName:"merchantListingPage" });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  confirmDelete = merchantID => {
    this.props.delete_merchant(merchantID);
  };

  componentDidMount() {
    this.props.clearAlert();
    this.handlePageChange(1);
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.merchantList !== nextProps.merchantList) {
      if (nextProps.merchantList) {
        const setPageCount =
          nextProps.merchantList.total / nextProps.merchantList.per_page;
        this.setState({
          merchantList: nextProps.merchantList.data,
          totalRecords: nextProps.merchantList.total,
          perPage: nextProps.merchantList.per_page,
          pageCount: setPageCount
        });
      }
    }

    if (
      this.props.deletedmerchantresponse !== nextProps.deletedmerchantresponse
    ) {
      if (!isEmpty(nextProps.deletedmerchantresponse)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.deletedmerchantresponse.message
        );
        this.props.get_merchant_list({ page: this.state.currentPage, limit: this.state.limit, pageName:"merchantListingPage" });
      }
    }

    if (
      this.props.updatedMerchant !== nextProps.updatedMerchant
    ) {
      if (!isEmpty(nextProps.updatedMerchant)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert(
          "success",
          nextProps.updatedMerchant.message
        );
        this.props.get_merchant_list({ page: this.state.currentPage, limit: this.state.limit, pageName:"merchantListingPage" });
      }
    }

    
    if (this.props.error !== nextProps.error && !isEmpty(nextProps.error)) {
      this.props.clearAlert();
      this.handleShow();
      this.props.renderAlert("warning", nextProps.error);
    }

    if (this.props.message !== nextProps.message) {
      if (nextProps.message) {
        this.setState({
          alertMessage: nextProps.message,
          msgType: nextProps.alertType
        });
      }
    }
  }

  handleDelete = merchantID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(merchantID);
        })
      ]
    });
  };

  handleMerchantStatus = (key) => {
    if(key === 1){
      this.setState({tabStatus : 'Active'});
      this.getMerchantListByStatus(1, 'Active');
    }else if(key === 2){
      this.setState({tabStatus : 'Inactive'});
      this.getMerchantListByStatus(1, 'Inactive');
    }else if(key === 3){
      this.setState({tabStatus : 'Deleted'});
      this.getMerchantListByStatus(1, 'Deleted');
    }else{
      this.setState({tabStatus : 'Active'});
      this.getMerchantListByStatus(1, 'Active');
    }
  }

  getMerchantListByStatus = (page, status) => {
    this.setState({
      currentPage: page
    });
    this.props.get_merchant_list({ status: status, page: page,  limit: this.state.limit, pageName:"merchantListingPage"});
  };

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let merchantRow;
    if (!isEmpty(this.props.merchantList) && this.props.merchantList.data) {
      merchantRow = this.props.merchantList.data.map((merchant, index) => (
        <tr key={index}>
          <td className="wrap-text">{merchant.merchantName}</td>
          <td className="wrap-text">{merchant.email}</td>
          <td className="wrap-text">{merchant.firstName}</td>
          <td className="wrap-text">{merchant.lastName}</td>
          <td>{merchant.status}</td>
          <td>
         
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                {aclUtil.checkACL('EDIT_MERCHANT') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addMerchant/${merchant.merchantID}`)}>Edit</MenuItem>):("")}
                {aclUtil.checkACL('VIEW_MERCHANT') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/merchantDetails/${merchant.merchantID}`)}>View</MenuItem>):("")}
                {aclUtil.checkACL('W9INFO') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/merchant/w9info/${merchant.merchantID}`)}>W9 Info</MenuItem>):("")}
                {aclUtil.checkACL('ADD_CONTRACT') ? (<MenuItem eventKey={Math.random()} onClick={() =>  this.context.router.history.push(`/addContract/${merchant.merchantID}/new`)}>Create Contract</MenuItem>):("")}
                <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/contractList/${merchant.merchantID}`)}>View Contract</MenuItem>
                {(this.state.userType !== 'finance') &&
                <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/dealList/${merchant.merchantID}`)}>View Offers</MenuItem>
                }
                {aclUtil.checkACL('ARCHIVE_MERCHANT') ? (
                (merchant.status === 'Deleted') ?
                <MenuItem eventKey={Math.random()} onClick={this.handleUnArchive.bind(this, merchant.user_id, merchant.merchantName)}> Un-Archive</MenuItem>
                :
                <MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, merchant.user_id)}>Archive</MenuItem>
                ):("")}
                <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/merchant/dashboard/${merchant.user_id}`)}>Dashboard</MenuItem>
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }
    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Merchant List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  {aclUtil.checkACL('ADD_MERCHANT') ? (
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/addMerchant")}
                    >
                      + Add New Merchant
                    </Button>)
                    : ("")}
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="row">
                <div className="col-lg-12">
                <Tabs activeKey={this.state.key} onSelect={this.handleMerchantStatus} id="controlled-tab-example">                      
                  <Tab eventKey={1} title="Active Merchant">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th onClick={this.handleSort("merchantName")}>
                            Merchant Name<span
                              className={this.state.merchantNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("email")}>
                            Email <span
                              className={this.state.emailSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("firstName")}>
                            First Name<span
                              className={this.state.firstNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("lastName")}>
                            Last Name<span
                              className={this.state.lastNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>{merchantRow}</tbody>
                    </table>

                    <div className="text-center">
                      <Pagination
                        total={totalRecords}
                        limit={perPage}
                        pageCount={5}
                        currentPage={currentPage}
                      >
                        {({
                          pages,
                          currentPage,
                          hasNextPage,
                          hasPreviousPage,
                          previousPage,
                          nextPage,
                          totalPages,
                          getPageItemProps
                        }) => (
                          <div className="pagination">
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: 1,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              First
                            </button>

                            {hasPreviousPage && (
                              <button className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: previousPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {"<"}
                              </button>
                            )}

                            {pages.map(page => {
                              let activePage = null;
                              if (currentPage === page) {
                                activePage = {
                                  backgroundColor: "#ccc",
                                  color: "#666"
                                };
                              }
                              return (
                                <button className="btn btn-default"
                                  key={page}
                                  style={activePage}
                                  {...getPageItemProps({
                                    pageValue: page,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  {page}
                                </button>
                              );
                            })}

                            {hasNextPage && (
                              <button className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: nextPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {">"}
                              </button>
                            )}

                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: totalPages,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              Last
                            </button>
                          </div>
                        )}
                      </Pagination>
                    </div>
                  </Tab>
                  <Tab eventKey={2} title="Inactive Merchant">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th onClick={this.handleSort("merchantName")}>
                            Merchant Name<span
                              className={this.state.merchantNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("email")}>
                            Email <span
                              className={this.state.emailSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("firstName")}>
                            First Name<span
                              className={this.state.firstNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("lastName")}>
                            Last Name<span
                              className={this.state.lastNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>{merchantRow}</tbody>
                    </table>

                    <div className="text-center">
                      <Pagination
                        total={totalRecords}
                        limit={perPage}
                        pageCount={5}
                        currentPage={currentPage}
                      >
                        {({
                          pages,
                          currentPage,
                          hasNextPage,
                          hasPreviousPage,
                          previousPage,
                          nextPage,
                          totalPages,
                          getPageItemProps
                        }) => (
                          <div className="pagination">
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: 1,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              First
                            </button>

                            {hasPreviousPage && (
                              <button className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: previousPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {"<"}
                              </button>
                            )}

                            {pages.map(page => {
                              let activePage = null;
                              if (currentPage === page) {
                                activePage = {
                                  backgroundColor: "#ccc",
                                  color: "#666"
                                };
                              }
                              return (
                                <button className="btn btn-default"
                                  key={page}
                                  style={activePage}
                                  {...getPageItemProps({
                                    pageValue: page,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  {page}
                                </button>
                              );
                            })}

                            {hasNextPage && (
                              <button className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: nextPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {">"}
                              </button>
                            )}

                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: totalPages,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              Last
                            </button>
                          </div>
                        )}
                      </Pagination>
                    </div>
                  </Tab>
                  <Tab eventKey={3} title="Archived Merchant">
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th onClick={this.handleSort("merchantName")}>
                            Merchant Name<span
                              className={this.state.merchantNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("email")}>
                            Email <span
                              className={this.state.emailSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("firstName")}>
                            First Name<span
                              className={this.state.firstNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th onClick={this.handleSort("lastName")}>
                            Last Name<span
                              className={this.state.lastNameSortIcon}
                              aria-hidden="true"
                            />
                          </th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>{merchantRow}</tbody>
                    </table>

                    <div className="text-center">
                      <Pagination
                        total={totalRecords}
                        limit={perPage}
                        pageCount={5}
                        currentPage={currentPage}
                      >
                        {({
                          pages,
                          currentPage,
                          hasNextPage,
                          hasPreviousPage,
                          previousPage,
                          nextPage,
                          totalPages,
                          getPageItemProps
                        }) => (
                          <div className="pagination">
                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: 1,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              First
                            </button>

                            {hasPreviousPage && (
                              <button className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: previousPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {"<"}
                              </button>
                            )}

                            {pages.map(page => {
                              let activePage = null;
                              if (currentPage === page) {
                                activePage = {
                                  backgroundColor: "#ccc",
                                  color: "#666"
                                };
                              }
                              return (
                                <button className="btn btn-default"
                                  key={page}
                                  style={activePage}
                                  {...getPageItemProps({
                                    pageValue: page,
                                    onPageChange: this.handlePageChange
                                  })}
                                >
                                  {page}
                                </button>
                              );
                            })}

                            {hasNextPage && (
                              <button className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: nextPage,
                                  onPageChange: this.handlePageChange
                                })}
                              >
                                {">"}
                              </button>
                            )}

                            <button className="btn btn-default"
                              {...getPageItemProps({
                                pageValue: totalPages,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              Last
                            </button>
                          </div>
                        )}
                      </Pagination>
                    </div>
                  </Tab>
                </Tabs>
              </div>
              </div>
              
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MerchantList.propTypes = {
  get_merchant_list: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  merchantList: state.merchantReducer.merchantList,
  error: state.merchantReducer.error,
  deletedmerchantresponse: state.merchantReducer.deletedmerchantresponse,
  addMerchantLocationResponse:
    state.merchantReducer.addMerchantLocationResponse,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  updatedMerchant: state.merchantReducer.updatedMerchant,
});

export default withRouter(connect(mapStateToProps, {
  get_merchant_list,
  delete_merchant,
  renderAlert,
  clearAlert,
  unArchive
})(MerchantList));


// WEBPACK FOOTER //
// ./src/app/views/admin/merchant/MerchantList.js